import { render, staticRenderFns } from "./StaticPageLoader.vue?vue&type=template&id=b5e2fec0"
import script from "./StaticPageLoader.vue?vue&type=script&lang=js"
export * from "./StaticPageLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports